import { render } from "./Summary.vue?vue&type=template&id=064bdad2"
import script from "./Summary.vue?vue&type=script&lang=js"
export * from "./Summary.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/360pt/V3/v2026.33.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__